import { Header } from '@/components/UI/Layouts/Main/Header';

const NotFound = () => (
  <div className="h-[calc(100vh-96px)]">
    <Header />
    <div className="flex-1 flex items-center justify-center text-2xl h-[100vh]">
      <div className="text-2xl">404 - Not Found</div>
    </div>
  </div>
);

export default NotFound;
